(function () {
  function bind(root) {
    if (root.dataset.bhSizeToggleBound === '1') return;
    root.dataset.bhSizeToggleBound = '1';
    var units = root.querySelector('.bh-units');
    if (!units) return;
    units.addEventListener('click', function (e) {
      var target = e.target.closest('label, button, [data-unit]');
      if (!target || !units.contains(target)) return;
      e.preventDefault();
      e.stopPropagation();
      var unit = target.getAttribute('data-unit');
      if (!unit) {
        var forAttr = target.getAttribute('for') || '';
        if (forAttr.indexOf('cm') !== -1) unit = 'cm';
        else if (forAttr.indexOf('in') !== -1) unit = 'in';
      }
      if (unit === 'cm') root.classList.add('is-cm');
      else if (unit === 'in') root.classList.remove('is-cm');
    }, true);
  }
  function init() {
    document.querySelectorAll('.bh-sizetoggle').forEach(bind);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-bind on Shopify section reloads
  document.addEventListener('shopify:section:load', init);
})();
